import style from './FormCheck.module.scss';

const FormCheck = ({ children, groupValue, value, onChange, mode, checked, ...attrs }) => {
  return (
    <label className={`${style.check} ${style['check-' + mode]}`}>
      <input
        value={value}
        onChange={() => onChange(value)}
        checked={typeof checked !== 'undefined' ? checked : value === groupValue}
        {...attrs}
      />
      <span>{children}</span>
    </label>
  );
};

export default FormCheck;
